import { render } from "./VariavelEdicao.vue?vue&type=template&id=3548c050&scoped=true&ts=true"
import script from "./VariavelEdicao.vue?vue&type=script&lang=ts"
export * from "./VariavelEdicao.vue?vue&type=script&lang=ts"

import "./VariavelEdicao.vue?vue&type=style&index=0&id=3548c050&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3548c050"]])

export default __exports__